import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const FilledArrowRightGlyph = /*#__PURE__*/createElement("g", {
  id: "filled_arrow_right"
}, /*#__PURE__*/createElement("path", {
  d: "M33,64.2c0,1.1,0.6,1.4,1.4,0.6l21.3-21.1c0.8-0.8,0.8-2,0-2.8L34.4,19.3c-0.8-0.8-1.4-0.5-1.4,0.6V64.2z"
}));
const FilledArrowRight = createSvg({
  name: 'filled_arrow_right',
  path: FilledArrowRightGlyph
});

export default FilledArrowRight;
export { FilledArrowRightGlyph };
